(() => {
  const galleries = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-photos]').forEach(gallery => {
      if (galleries.has(gallery)) return;
      galleries.add(gallery);
      let visible = false;
      let frame = 0;
      const warm = () => {
        frame = 0;
        if (!visible || !gallery.isConnected) return;
        const slides = [...gallery.querySelectorAll('.product-main-slide')]
          .filter(slide => !slide.classList.contains('hide') && slide.getClientRects().length);
        if (!slides.length) return;
        let index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        if (index < 0) index = slides.findIndex(slide => slide.querySelector('img[fetchpriority="high"]'));
        if (index < 0) index = 0;
        const main = slides[index].querySelector('img');
        const load = (slide, priority) => slide?.querySelectorAll('img').forEach(img => {
          if (img.fetchPriority !== 'high') img.fetchPriority = priority;
          img.loading = 'eager';
        });
        load(slides[index], 'auto');
        const neighbours = () => {
          if (!visible || !gallery.isConnected) return;
          [1, -1, 2].forEach(offset => load(slides[(index + offset + slides.length) % slides.length], 'low'));
        };
        if (!main || main.complete) neighbours();
        else main.addEventListener('load', neighbours, {once:true});
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(warm); };
      const changes = new MutationObserver(schedule);
      changes.observe(gallery, {subtree:true, childList:true, attributes:true, attributeFilter:['class']});
      gallery.addEventListener('pointerdown', schedule, {passive:true});
      gallery.addEventListener('focusin', schedule);
      const visibility = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        if (visible) schedule();
      }, {rootMargin:'100px'});
      visibility.observe(gallery);
      gallery.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        visibility.disconnect();changes.disconnect();cancelAnimationFrame(frame);
      }, {once:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
